import styled from 'styled-components';

export const Container = styled.div`
  > div {
    margin-bottom: 1.5rem;
  }

  p.Mui-error {
    margin-top: 0;
  }
`;

export const Wrapper = styled.div`
  > div {
    margin-bottom: 1.5rem;
  }

  p.Mui-error {
    margin: 0;
  }
`;
